import React, { useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import FilledNumberTextFieldLight from './FilledNumberTextFieldLight'
import { useSelector, shallowEqual } from 'react-redux'
import { unitSuffixSelector, hasUnitsSelector, unitNameSelector } from '../../../../redux/selectors'
import { fetchUnits } from '../../../../redux/actions'
import { useDispatch } from 'react-redux'
import QuestionContainer from './QuestionContainer'
import { Field } from 'redux-form'
import { useState } from 'react'
import { required, minMaxValueRequired, isValidNumber } from '../../../../utilties/validators'

const minMaxValueRequiredValidator = minMaxValueRequired
const isValidNumberValidator = isValidNumber
const requiredValidator = required

export default ({
	question,
	position,
	positionDisplay,
	value,
	input,
	validate,
	onQuestionValueChanged,
	isBilateral,
	isBilateralFullInfo,
	displayInstructionAsIcon,
	uniqueKey,
	...custom
}) => {
	const dispatch = useDispatch()

	const isLabelContainerPreserved = !!isBilateral && !!isBilateralFullInfo
	const name = `answers.number._${question.uniqueId}._${uniqueKey}`

	let units = useSelector(unitSuffixSelector, shallowEqual)
	let unitNames = useSelector(unitNameSelector, shallowEqual)
	let hasUnits = useSelector(hasUnitsSelector, shallowEqual)
	const [ validators, setValidators ] = useState()
	useEffect(
		() => {
			if (!hasUnits) {
				dispatch(fetchUnits())
			}
		},
		[ hasUnits ]
	)
	useEffect(
		() => {
			const validators = []

			if (question.isVisible) {
				validators.push.apply(validators, [ minMaxValueRequiredValidator, isValidNumberValidator ])
			}

			if (question && !question.isOptional) {
				validators.push(requiredValidator)
			}

            if (validate) {
                validators.push.apply(validators, validate)
			}

			setValidators(validators)
		},
		[ question, question.isVisible ]
	)

	const handleValueChanged = (e) => {
		onQuestionValueChanged(question, e.target.value)
	}

	return (
		<Grid>
			<QuestionContainer
				data-testid="number-question"
				title={`${question.title}`} titleRequered = {`${question.isOptional ? '' : ' *'}`}
				position={position}
				instructions={question.instructions}
				positionDisplay={positionDisplay}
				isBilateral={isBilateral}
				displayInstructionAsIcon={displayInstructionAsIcon}
				children={
					<Grid
						container
					>
						{
							!!isLabelContainerPreserved
							&& <Grid xs={6} />
						}
						<Grid
							item
							xs={isLabelContainerPreserved ? 6 : 12}
						>
							<Grid container alignItems="center" spacing={2} style={{flexWrap: 'nowrap'}}>
								<Grid item style={{ flex: 0.7 }}>
									<Field
										data-testid="number-question-field"
										component={FilledNumberTextFieldLight}
										type="number"
										allowDecimal={true}
										digitsAllowed={question.digits ? question.digits : 5}
										style={{ paddingTop: '7px' }}
										value={value}
										name={name}
										validate={validators}
										onChange={handleValueChanged}
										{...custom}
									/>
								</Grid>
								<Grid item style={{ flex: 0.3, alignSelf: 'flex-start', height: '63px', display: 'flex', alignItems: 'flex-end'}}>
									<Typography
										aria-label={unitNames(question.unitId)}
										data-testid="number-question-item" variant="subtitle1" style={{ fontWeight: '400', marginBottom: '0' }}>
										{units(question.unitId)}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				}
			/>
		</Grid>
	)
}
